import React from "react";
import { Box, Skeleton, Paper } from '@mui/material';

const DocumentGridSkeleton = ({ rowCount = 8 }) => {
    return (
        <Box sx={{ width: '100%', maxHeight: '75vh' }}>
            {/* Toolbar Skeleton */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                p: 1,
                borderBottom: '1px solid rgba(224, 224, 224, 1)',
                minHeight: 52
            }}>
                <Skeleton variant="rectangular" width={120} height={36} sx={{ borderRadius: 1 }} />
            </Box>

            {/* Header Row Skeleton */}
            <Box sx={{
                display: 'flex',
                backgroundColor: 'rgba(245, 245, 245, 1)',
                borderBottom: '1px solid rgba(224, 224, 224, 1)',
                minHeight: 56,
                alignItems: 'center'
            }}>
                {/* Actions column */}
                <Box sx={{ width: 100, px: 2, display: 'flex', justifyContent: 'center' }}>
                    <Skeleton variant="text" width={60} height={20} />
                </Box>
                {/* Other columns */}
                {[
                    'Document Name',
                    'Status',
                    'Page Count',
                    'Uploaded Date',
                    'Bank Account',
                    'Begin Date',
                    'End Date'
                ].map((header, index) => (
                    <Box key={index} sx={{ width: 200, px: 2 }}>
                        <Skeleton variant="text" width="80%" height={20} />
                    </Box>
                ))}
            </Box>

            {/* Data Rows Skeleton */}
            <Box sx={{ maxHeight: '70vh', overflow: 'hidden' }}>
                {Array.from({ length: rowCount }).map((_, rowIndex) => (
                    <Box
                        key={rowIndex}
                        sx={{
                            display: 'flex',
                            borderBottom: '1px solid rgba(224, 224, 224, 1)',
                            minHeight: 52,
                            alignItems: 'center',
                            '&:hover': {
                                backgroundColor: 'rgba(0, 0, 0, 0.04)'
                            }
                        }}
                    >
                        {/* Actions column - PDF icon skeleton */}
                        <Box sx={{ width: 100, px: 2, display: 'flex', justifyContent: 'center' }}>
                            <Skeleton variant="circular" width={24} height={24} />
                        </Box>

                        {/* Document Name */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton
                                variant="text"
                                width={Math.random() * 100 + 120} // Random width between 120-220
                                height={20}
                            />
                        </Box>

                        {/* Status */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton
                                variant="text"
                                width={Math.random() * 60 + 60} // Random width between 60-120
                                height={20}
                            />
                        </Box>

                        {/* Page Count */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton variant="text" width={30} height={20} />
                        </Box>

                        {/* Uploaded Date */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton variant="text" width={100} height={20} />
                        </Box>

                        {/* Bank Account */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton
                                variant="text"
                                width={Math.random() * 80 + 80} // Random width between 80-160
                                height={20}
                            />
                        </Box>

                        {/* Begin Date */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton variant="text" width={80} height={20} />
                        </Box>

                        {/* End Date */}
                        <Box sx={{ width: 200, px: 2 }}>
                            <Skeleton variant="text" width={80} height={20} />
                        </Box>
                    </Box>
                ))}
            </Box>
        </Box>
    );
};

export default DocumentGridSkeleton;